module.exports = __webpack_public_path__ + "static/firstTile-65b4f9aff4ed45715331296ba3bf8b30.jpeg";